module.exports = __webpack_public_path__ + "img/cute-hamster.6440ac02.png";